import React, { lazy as ReactLazy } from "react"

import { withSuspense } from "./with-suspense"
import { prerenderedLazy } from "./prerender-lazy"

export type DynamicImportType = () => Promise<{ default: React.ComponentType<any> }>

export function lazy<T>(dynamicImport: DynamicImportType, { prerender = true }: { prerender?: boolean } = {}) {
  const component = prerender ? prerenderedLazy(dynamicImport) : ReactLazy(dynamicImport)

  return withSuspense<T>(component)
}
